import { Component, Input, OnInit } from '@angular/core';
import * as fromModels from 'src/app/shared/models';
import { User } from 'src/app/models/entities';
import { AuthService } from 'src/app/services/auth.service';
import { urlsPrivate } from 'src/environments/url-services';
import {ActivatedRoute, Router} from '@angular/router';
import {LevelconsultService} from 'src/app/services/levelconsult.service';
import {LevelservicesService} from 'src/app/services/levelservices.service';
import {LevelservicesDetailComponent} from 'src/app/site-private/level/process-levelservices/components/detail/levelservices-detail.component';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  userData: User;
  modelBreadCrumb: fromModels.Breadcrumb;
  serviceConsult: boolean;
  @Input()
  public set _modelBreadCrumb(model: fromModels.Breadcrumb){
    this.modelBreadCrumb = model;
    for(const item of this.modelBreadCrumb.last)
      console.log(item.seccion)
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private levelConsult: LevelconsultService,
    private route: ActivatedRoute,
    private levelservicesServices: LevelservicesService
  ) {


  }

  ngOnInit(): void {
    this.userData = this.authService.currentUserValue;
  }


  back() {
    const dataConsult = this.levelConsult.get_localstorage('dataConsult');
    if(dataConsult?.from){
       this.router.navigate(['../../../'], { relativeTo: this.route, queryParams: { userConsult: 1 } });
    }
    else{
       this.router.navigate(['/']);
    }
  }


  backCapa(){
    const { urlOri, v } = this.route.snapshot.queryParams;
    if (!v) {
      this.router.navigate([`app/admin/capadeuso/filter`], { queryParams: { capasConsult: 1 }});
    } else {
      this.router.navigate([urlOri]);
    }
  }

  cancelEditCapa(){
    const { id } = this.route.snapshot.params;
    this.router.navigate([`../../show/`, +id], { relativeTo: this.route });
    window.scrollTo(0, 0);
  }
  backVersionarCapa() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  regresar() {
      const datosConsultaServicios = this.levelservicesServices.get_localstorage('datosConsultaServicios');
      this.serviceConsult = this.levelservicesServices.getdataConsultService();
      const entidadConsulta = this.levelservicesServices.getdataConsultaEntidad();

      if (this.serviceConsult) {
        this.router.navigate(['app/level/process-levelconsult'], { queryParams: { userConsult: 1 } });
        //this.levelservicesServices.deletedataConsultService();
      }
      else if(entidadConsulta){
        this.router.navigate(['/app/admin/entities'], { queryParams: { entitiesConsult: 1 } });
        //this.levelservicesServices.deletedataConsultaEntidad();
      }
      else {
        this.router.navigate(['app/level/process-levelservices/home'], { queryParams: { dataLevelServices: 1 } });
        this.levelservicesServices.deletedata();
        this.levelservicesServices.deletedataEdit();
      }
  }

  usersConsult() {
      this.router.navigate(['/app/admin/users'], { queryParams: { userConsult: 1 } });
  }

  backEntidad(): void {
      const { from } = this.route.snapshot.queryParams;
      if (from == 'level-consult') {
        this.router.navigate(['app/level/process-levelconsult'], { queryParams: { userConsult: 1 } });
      } else if (from == 'level-services') {
        this.router.navigate(['app/level/process-levelservices/home'], { queryParams: { dataLevelServices: 1 } });
      } else {
        this.router.navigate(['/app/admin/entities'], { queryParams: { entitiesConsult: 1 } });
      }
  }

}
